<template>
  <div class="settings scrollbar">
    <div class="settings-header">
      <button type="button" class="history-back" @click="previous">
        <arrow-left-icon></arrow-left-icon>
      </button>
      Settings

    </div>

    <hr class="settings-divider"/>

    <div v-if="!offlineMode">

      <!--<button type="button" class="block">-->
      <!--<cloud-off-outline-icon></cloud-off-outline-icon>-->
      <!--<span class="settings-text" @click.once="switchToOffline">-->
      <!--Switch to offline mode-->
      <!--</span>-->
      <!--</button>-->
      <!--<button type="button" class="block" :disabled="fetching" @click.once="refreshAuthenticators">-->
      <!--<reload-icon></reload-icon>-->
      <!--<span class="settings-text">-->
      <!--Reload authenticators-->
      <!--</span>-->
      <!--</button>-->

      <!--<hr class="settings-divider">-->

      <p class="settings-head">
        User settings
      </p>

      <button type="button" class="block" :disabled="fetching" @click="postPersonalPreferences">
        <upload-icon></upload-icon>
        <span class="settings-text">
        Save to server<br>
        <small>Favorites, Settings and offline-passphrase</small>
      </span>
      </button>

      <button type="button" class="block" :disabled="fetching" @click="getPersonalPreferences">
        <download-icon></download-icon>
        <span class="settings-text">
        Import from server<br>
        <small>Favorites, Settings and offline-passphrase</small>
      </span>
      </button>

      <a :href="settingsUrl" class="block" target="_blank">
        <open-in-new-icon></open-in-new-icon>
        <span class="settings-text">
        Edit settings on server
      </span>
      </a>

      <hr class="settings-divider">
    </div>


    <p class="settings-head">
      Configuration
    </p>

    <router-link :to="{name: 'settings.authenticator'}" class="block">
      <settings-icon></settings-icon>
      <span class="settings-text">
       Authenticator settings
      </span>
    </router-link>

    <router-link :to="{name: 'settings.offline'}" class="block">
      <security-icon></security-icon>
      <span class="settings-text">
       Encrypted Offline mode
      </span>
    </router-link>

    <hr class="settings-divider">

    <p class="settings-head">
      Looking for more?
    </p>

    <button type="button" class="block" @click="showPrivacy">
      <view-list-icon></view-list-icon>
      <span class="settings-text">
        Privacy Policy
      </span>
    </button>

    <button type="button" class="block" @click="showDisclaimer">
      <alert-icon></alert-icon>
      <span class="settings-text">
        Disclaimer
      </span>
    </button>

    <button type="button" class="block" @click="showHelp">
      <help-circle-icon></help-circle-icon>
      <span class="settings-text">
        Help
      </span>
    </button>

    <small class="version">v{{version}}</small>

  </div>
</template>

<script>
  import EventHub from '@/events/event-hub';
  import {mapGetters, mapActions} from 'vuex';

  import ArrowLeftIcon from "vue-material-design-icons/ArrowLeft";
  import CloudOffOutlineIcon from "vue-material-design-icons/CloudOffOutline";
  import ReloadIcon from "vue-material-design-icons/Reload";
  import DownloadIcon from "vue-material-design-icons/Download";
  import UploadIcon from "vue-material-design-icons/Upload";
  import OpenInNewIcon from "vue-material-design-icons/OpenInNew";
  import HelpCircleIcon from "vue-material-design-icons/HelpCircle";

  import * as Toastr from 'toastr';
  import SettingsIcon from "vue-material-design-icons/Settings";
  import SecurityIcon from "vue-material-design-icons/Security";
  import ViewListIcon from "vue-material-design-icons/ViewList";
  import AlertIcon from "vue-material-design-icons/Alert";

  Toastr.options.timeout = 1500;

  export default {
    name: 'settings-list',
    components: {
      AlertIcon,
      ViewListIcon,
      SecurityIcon,
      SettingsIcon,
      HelpCircleIcon,
      OpenInNewIcon,
      UploadIcon,
      DownloadIcon,
      ReloadIcon,
      CloudOffOutlineIcon,
      ArrowLeftIcon
    },
    data() {
      return {
        fetching: false,
      };
    },
    computed: {
      ...mapGetters({
        offlineMode: 'auth/offlineMode',
        user: 'auth/user',
        authenticators: 'authenticators/all',
        filterTemplateOn: 'authenticators/filterTemplateOn',
        personalFolderId: 'authenticators/personalFolderId',
        filterFieldOn: 'authenticators/filterFieldOn',
        secrettemplates: 'secretTemplates/all',
        getTemplateById: 'secretTemplates/getById',
        templateId: 'authenticators/templateId',
        showOtp: 'settings/showOtp',
        okey: 'settings/okey',
        advancedTemplate: 'settings/advancedTemplate',
        storeOffline: 'settings/storeOffline',
        url: 'auth/url',
        favorites: 'authenticators/favorites',
        settingsId: 'authenticators/settingsId',
      }),
      version() {
        return process.env.PACKAGE_JSON;
      },
      settingsUrl() {
        if (this.settingsId) {
          return this.url + '/SecretView.aspx?secretid=' + this.settingsId;
        }
        return '#';
      },
    },
    methods: {
      ...mapActions({
        addFieldFilter: 'authenticators/addFieldFilter',
        addTemplateFilter: 'authenticators/addTemplateFilter',
        removeFieldFilter: 'authenticators/removeFieldFilter',
        removeTemplateFilter: 'authenticators/removeTemplateFilter',
        resetTemplateFilter: 'authenticators/resetTemplateFilter',
        resetFieldFilter: 'authenticators/resetFieldFilter',
        postSecret: 'authenticators/postSecret',
        getStub: 'authenticators/getStub',
        postPreferences: 'authenticators/postPreferences',
        getPreferences: 'authenticators/getPreferences',
        putSecret: 'authenticators/putSecret',
        getSecret: 'authenticators/getSecret',
        getPersonalFolderId: 'authenticators/getPersonalFolderId',
        patchSecretField: 'authenticators/patchSecretField',
      }),
      previous() {
        this.$router.push({name: 'authenticators'});
      },
      showHelp() {
        EventHub.$emit('help-show');
      },
      showDisclaimer() {
        EventHub.$emit('disclaimer-show');
      },
      showPrivacy() {
        EventHub.$emit('privacy-show');
      },
      postPersonalPreferences(e) {
        e.preventDefault();
        if (!this.offlineMode && this.personalFolderId) {

          this.fetching = true;
          this.postPreferences()
            .then(response => {
              if (typeof response == "undefined") {
                return Toastr.error('Unable to save settings.');
              }
              return Toastr.success('Settings and favorites saved.');

            })
            .catch(() => {
              return Toastr.error('Unable to save settings.');
            })
            .finally(() => {
              this.fetching = false;
            });
        }
      },
      getPersonalPreferences(e) {
        e.preventDefault();

        if (!this.offlineMode) {
          this.fetching = true;
          this.getPreferences(true)
            .then(result => {
              if (result == 0) {
                return Toastr.info('No settings found.');
              }
              if (typeof result !== 'undefined' && result >= 1) {
                return Toastr.success('Settings and favorites loaded.');
              }
            })
            .finally(() => {
              this.fetching = false;
            });
        }
      },
    },
    mounted() {
      if (!this.personalFolderId) {
        this.getPersonalFolderId();
      }
    }
  };
</script>

<style>
  .version {
    margin-bottom: 10px;
    color: #757575;
    width: 100%;
    display: block;

    text-align: right;
  }

  .history-back {
    font-size: 20px;
    height: 40px;
    width: 40px;
    margin-left: -20px;
    border: 0;
    padding: 0;
    background: transparent;
  }

  .settings {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
    background: white;
    padding: 0 20px;
  }

  .settings-block {
    margin: 10px 0;
  }

  .settings-body {
    padding: 10px 0;
  }

  .settings-header {
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    /*border-bottom: 1px solid #C8C8C8;*/
    font-weight: bold;
    margin-top: 10px;
  }

  .settings-head {
    line-height: 30px;
    margin: 0;
    padding: 0 15px;
    font-size: 15px;
    color: #3f3f3f;
    font-weight: bold;
  }

  .settings-footer {
    border-bottom: 1px solid #C8C8C8;
  }

  .settings-body span {
  }

  .block .material-design-icon {
    top: -3px;
  }

  .settings-text {
    width: 100%;
    flex-direction: column;
    margin: auto;
    padding: 0 15px;
    /*color: black;*/
    color: #4a148c;
    display: flex;
  }

  .settings-select {
    max-width: 30%;
    float: right;
    margin-left: auto;
    margin-right: 10px;
    min-width: 90px;
  }

  .settings .block {
    display: flex;
    padding: 0 5px;
    margin: 10px 0;
    min-height: 40px;
    width: 100%;
    text-align: left;
    border: 0;
    background: white;
    cursor: pointer;
    color: #000;
    transition: background-color 200ms ease-in-out;
  }

  .settings .block:disabled,
  .settings .block:disabled .settings-text {
    color: #757575;
  }

  .block:hover,
  .block:focus,
  .block::selection {
    background: #f5f5f5;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/SettingsList.vue